import { apiGet, apiPatch } from './client';
import type {
  SpecialCreationLimit,
  SpecialCreationLimitBatchRequest,
} from '../types/SpecialCreationLimit';

// Tenant-scoped (X-Tenant-Id applied automatically by the client).
export function getSpecialCreationLimits(): Promise<SpecialCreationLimit[]> {
  return apiGet<SpecialCreationLimit[]>('/api/special-creation-limits');
}

export function saveSpecialCreationLimitsBatch(
  added: SpecialCreationLimit[],
  modified: SpecialCreationLimit[],
  deletedIds: number[],
): Promise<SpecialCreationLimit[]> {
  return apiPatch<SpecialCreationLimitBatchRequest, SpecialCreationLimit[]>(
    '/api/special-creation-limits/batch',
    { added, modified, deleted: deletedIds },
  );
}
